import {get, post, postJson} from '../axios'

const RESOURCE_BASE_PATH = ''
// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms'

// 获取人群数量
export const getMemberCrowd = p => get(`${RESOURCE_BASE_PATH}/memberCrowd/`, p);




